import { useMutation } from '@apollo/client/react';
import { ConfirmationDialog } from '@optools/components/dialog/confirmation-dialog';
import { Spinner } from '@optools/components/loading/spinner';
import { Button } from '@optools/components/ui/button';
import { ButtonGroup } from '@optools/components/ui/button-group';
import { TOGGLE_ALL_SKYVIEW_CONFIGS } from '@optools/services/operator-gateway/btc/mutations';
import { SKYVIEW_CONFIGS } from '@optools/services/operator-gateway/btc/queries';
import { ToggleLeft, ToggleRight } from 'lucide-react';

export interface SkyviewGlobalConfigActionsProps {
  enabled: boolean;
  partiallyEnabled: boolean;
}

export function SkyviewGlobalConfigActions({
  enabled,
  partiallyEnabled,
}: SkyviewGlobalConfigActionsProps) {
  const [toggleSkyviewAllConfigs, { loading }] = useMutation(TOGGLE_ALL_SKYVIEW_CONFIGS, {
    awaitRefetchQueries: true,
    refetchQueries: [{ query: SKYVIEW_CONFIGS }],
  });

  return (
    <ButtonGroup className="items-center">
      {loading && <Spinner variant="loader" />}
      {(enabled || partiallyEnabled) && (
        <ButtonGroup>
          <ConfirmationDialog
            description="Are you sure you want to disable all Skyview configs?"
            title="Disable All Skyview Configs"
            onConfirm={() => toggleSkyviewAllConfigs({ variables: { enabled: false } })}>
            <Button disabled={loading} variant="outline">
              <ToggleLeft />
              Disable All Configs
            </Button>
          </ConfirmationDialog>
        </ButtonGroup>
      )}
      {(!enabled || partiallyEnabled) && (
        <ButtonGroup>
          <ConfirmationDialog
            description="Are you sure you want to enable all Skyview configs?"
            title="Enable All Skyview Configs"
            onConfirm={() => toggleSkyviewAllConfigs({ variables: { enabled: true } })}>
            <Button disabled={loading} loading={false} variant="secondary">
              <ToggleRight />
              Enable All Configs
            </Button>
          </ConfirmationDialog>
        </ButtonGroup>
      )}
    </ButtonGroup>
  );
}
